import { forwardRef } from "react";
import { FieldError } from "react-hook-form";
import {
  Checkbox,
  Field,
  HoverEffect,
  PlainLink,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

interface TermsAndCondProps {
  error?: FieldError;
}

const TERMS_OF_SERVICE_ARTICLE = "https://gocardless.com/legal/";
const PRIVACY_NOTICE = "https://gocardless.com/privacy";

export const TermsAndConditionsCheck = forwardRef<
  HTMLInputElement,
  TermsAndCondProps
>(({ ...field }, ref) => (
  <Field data-testid="terms_and_conditions">
    <Checkbox
      {...field}
      id="terms_and_conditions"
      name="terms_and_conditions"
      ref={ref}
    >
      <Trans id="terms-and-conditions.text-1">I agree to the</Trans>{" "}
      <PlainLink
        href={TERMS_OF_SERVICE_ARTICLE}
        textDecoration="underline"
        effect={HoverEffect.TextDecoration}
        target="_blank"
      >
        <Trans id="terms-and-conditions.text-2">
          terms of service and incorporated terms
        </Trans>
      </PlainLink>{" "}
      <Trans id="terms-and-conditions.text-3">
        and understand GoCardless uses personal data as described in our
      </Trans>{" "}
      <PlainLink
        href={PRIVACY_NOTICE}
        textDecoration="underline"
        effect={HoverEffect.TextDecoration}
        target="_blank"
      >
        <Trans id="Privacy notice">privacy notice</Trans>
      </PlainLink>
      .
    </Checkbox>
  </Field>
));
